import { TextField } from "@mui/material";

interface Props {
  value: number | "";
  onChange: (value: number | "") => void;
  label?: string;
  min?: number;
  max?: number;
  size?: "small" | "medium";
  sx?: object;
}

/**
 * Free-text numeric field: digits only, fully clearable, no spinner arrows
 * (unlike <input type="number">). Empty maps to "". Clamped to [min, max].
 */
export default function NumberField({
  value,
  onChange,
  label,
  min,
  max,
  size = "small",
  sx,
}: Props) {
  return (
    <TextField
      type="text"
      inputMode="numeric"
      size={size}
      label={label}
      value={value === "" ? "" : String(value)}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9]/g, "");
        if (raw === "") {
          onChange("");
          return;
        }
        let n = parseInt(raw, 10);
        if (min != null) n = Math.max(min, n);
        if (max != null) n = Math.min(max, n);
        onChange(n);
      }}
      sx={sx}
    />
  );
}
